import(/* webpackMode: "eager" */ "/usr/src/app/src/header/Header.tsx");
import(/* webpackMode: "eager" */ "/usr/src/app/src/footer/Footer.tsx")